const config = typeof window !== "undefined" && window.APP_CONFIG
  ? window.APP_CONFIG
  : {};

export const constantURL = config.constantURL || "";
export const WMSDB = config.WMSDB || "";
export const ASAPDB = config.ASAPDB || "";
